import { FC, Ref } from 'react';
import styled from 'styled-components';
import { DefaultList, ListPure, ListStyleProvider } from '@clds/compound-components';
import Popover from '@clds/popover';
import { MenuProvider } from '@clds/menu-old';
import { SIDE_MENU_WIDTH } from '../../SideMenu/SideMenu.styled';
import { useCustomMenuState } from './useCustomMenu';
import { CustomDropdownMenuProps } from './CustomDropdownMenu.typs';
import { HorizontalSeparator } from '@clds/separator';

export const CustomDropdownMenu: FC<CustomDropdownMenuProps> = ({ searchBar, footer, header, popoverProps, ...rest }) => {
  const { menu, dropdownMenu } = useCustomMenuState(rest);

  return (
    <Popover
      {...dropdownMenu.popoverProps}
      {...popoverProps}
      trigger="click"
      placement="top"
      paperProps={{ isPadded: false, borderRadius: 'md' }}
      overlay={
        <StyledListPure ref={dropdownMenu.navigationRef as Ref<HTMLDivElement>} {...menu.focusableProps}>
          {header && (
            <>
              {header}
              <HorizontalSeparator horizontalMargin="sm" />
            </>
          )}
          <ScrollableWrapper>
            <MenuProvider {...menu.menuProviderProps}>
              <ListStyleProvider selectionVariant="subtle" borderRadius="md">
                <StyledList ref={menu.descendantsParentRef}>{dropdownMenu.connectedItems}</StyledList>
              </ListStyleProvider>
            </MenuProvider>
          </ScrollableWrapper>
          {searchBar}
          {footer}
        </StyledListPure>
      }
    >
      {dropdownMenu.connectedTrigger}
    </Popover>
  );
};

export const MENU_ITEM_HEIGHT = '2rem';

const ScrollableWrapper = styled.div`
  flex-grow: 1;
  overflow-y: auto;
`;

const StyledListPure = styled(ListPure)`
  width: calc(${SIDE_MENU_WIDTH} - 2px);
  overflow: hidden;
`;

const StyledList = styled(DefaultList)`
  max-height: calc(8 * ${MENU_ITEM_HEIGHT}); // 8 items * MENU_ITEM_HEIGHT
`;
